import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function resolveImage(src) {
  if (!src) return "https://images.unsplash.com/photo-1635767798638-3e25273a8236?crop=entropy&cs=srgb&fm=jpg&q=85";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/")) return src; // local asset served from frontend public/
  return `${API}/files/${src}`;
}

export function formatINR(amount) {
  return "₹" + Number(amount || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export default api;
